import { FormProvider, useForm } from "react-hook-form";
import Modal from "../../../../components/common/Modal";
import TextInput from "../../../../components/common/TextInput";
import Select from "../../../../components/common/Select";
import Button from "../../../../components/common/button";

import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import useGetEligibilityCriteriaQuery from "../../../../hooks/use-get-eligibility-criteria";
import VideoRangeSelector from "../../../../components/common/VideoUploader";
import FileDropZone from "../../../../components/common/FileDropzon";
import { IVideos } from "../../../../utils/types";
import useAddOurStory from "../../../../hooks/use-our-story";
import { queryClient } from "../../../../App";
import { useNavigate, useParams } from "react-router";
import useUpdateOurStory from "../../../../hooks/use-update-our-story";
import { useUploadProgress } from "../../../../context/UploadProgressContext";
import DynamicMultiSelect from "../../../../components/common/DynamicMultiSelect";

interface IOptions {
  label: string;
  value: string;
}

interface IFormData {
  name: string;
  eligibilityCriteria: IOptions | null;
  value: IOptions | IOptions[] | null;
  file: File | File[] | null;
  thumbnail?: File | null;
  mediaType: 'video' | 'image';
}

const AddOurStortyModal = ({
  videoData,
  isEditVideo,
  isOpen = false,
  onSuccess,
  closeModal,
  modalTitle,
  maxVideoDuration,
  maxImages,
}: {
  videoData?: IVideos;
  isEditVideo?: boolean;
  createNew?: boolean;
  isOpen?: boolean;
  onSuccess?: () => void;
  closeModal?: () => void;
  categoryName?: string;
  modalTitle?: string;
  maxVideoDuration?: number;
  maxImages?: number;
}) => {
  const [eligibilityCriteriaOptions, setEligibilityCriteriaOptions] = useState<
    Array<IOptions>
  >([]);
  const [previousFile, setPreviousFile] = useState<string>("");
  const [previousFiles, setPreviousFiles] = useState<string[]>([]);
  const [mediaType, setMediaType] = useState<'video' | 'image'>('video');
  const { uploadPercentage, isProcessing } = useUploadProgress();

  const {
    data: eligibilityCriteriaData,
    // isLoading: eligibilityCriteriaLoading,
  } = useGetEligibilityCriteriaQuery();

  const eligibilityOptions =
    eligibilityCriteriaData?.result?.data
      .sort((b, a) => b.viewRank - a.viewRank)
      .map((x) => ({
        label: x.name,
        value: x._id,
      })) || [];

  const methods = useForm<IFormData>({
    defaultValues: {
      name: "",
      eligibilityCriteria: null,
      value: null,
      mediaType: 'video',
    },
  });
  const { handleSubmit, reset, setValue, watch } = methods;
  const { eligibilityCriteria } = methods.watch();
  const watchedMediaType = watch('mediaType');

  const [dynamicOptionsReset, setdynamicOptionsReset] = useState<boolean>(true);
  const handleDynamicOptionsReset = () => {
    setdynamicOptionsReset(false);
  };
  const DynamicMultiSelectKeys = ["RESERVATION_NO"];
  const [valueTypeEligibility, setValueTypeEligibility] = useState<{
    valueType: string;
    key: string;
  }>({
    valueType: "",
    key: "",
  });

  useEffect(() => {
    const data =
      eligibilityCriteriaData?.result?.data.find(
        (ele) => ele._id === eligibilityCriteria?.value
      )?.options || [];
    setEligibilityCriteriaOptions(data);
  }, [eligibilityCriteria, eligibilityCriteriaData]);
  

  useEffect(() => {
    if (videoData && isEditVideo) {
      // Determine media type based on file URL or default to video
      const fileUrl = Array.isArray(videoData.url) ? videoData.url[0] : videoData.url;
      const isImage = fileUrl && /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);
      const detectedMediaType = isImage ? 'image' : 'video';
      setMediaType(detectedMediaType);
      setValue('mediaType', detectedMediaType);
      
      // Handle both single file and multiple files
      if (Array.isArray(videoData.url) && detectedMediaType === 'video') {
        setPreviousFiles(videoData.url);
        setPreviousFile(""); // Clear single file
      } else if (Array.isArray(videoData.images) && detectedMediaType === 'image') {
        setPreviousFiles(videoData.images as string[]);
        setPreviousFile(""); // Clear single file
      } else {
        setPreviousFile(videoData.url);
        setPreviousFiles([]); // Clear multiple files
      }
      
      

      const selectedEligibility = eligibilityCriteriaData?.result?.data.find(
        (option) => option._id === videoData.eligibilityCriteria
      );

      // Determine if this is a dynamic multi-select case
      const isDynamicMultiSelect =
        selectedEligibility?.key &&
        DynamicMultiSelectKeys.includes(selectedEligibility.key);

      setValueTypeEligibility({
        key: isDynamicMultiSelect
          ? "RESERVATION_NO"
          : selectedEligibility?.key ?? "",
        valueType: isDynamicMultiSelect
          ? "DYNAMIC_MULTI_SELECT"
          : selectedEligibility?.valueType ?? "",
      });

      // Handle both array and single value cases
      const getSelectedValues = () => {
        if (!selectedEligibility) return null;

        // For DYNAMIC_MULTI_SELECT or MULTI_SELECT cases
        if (
          isDynamicMultiSelect ||
          selectedEligibility.valueType === "MULTI_SELECT"
        ) {
          const values = Array.isArray(videoData.value)
            ? videoData.value
            : [videoData.value];

          // For dynamic options, we might not have them in eligibilityCriteria.options
          if (isDynamicMultiSelect) {
            return values.map((value) => ({
              label: value,
              value: value,
            }));
          }

          // For regular multi-select with predefined options
          return selectedEligibility.options
            .filter((option) => values.includes(option.value))
            .map((option) => ({
              label: option.label,
              value: option.value,
            }));
        }
        // For SINGLE_SELECT or TEXT cases
        else {
          const selectedValue = selectedEligibility.options.find(
            (option) => Array.isArray(videoData.value) ? videoData.value.includes(option.value) : videoData.value === option.value
          );

          return selectedEligibility.valueType === "TEXT"
            ? { label: videoData.value, value: videoData.value }
            : selectedValue || null;
        }
      }; 
      console.log("getSelectedValues", getSelectedValues());
      
      reset({
        name: videoData.name || "",
        eligibilityCriteria: {
          label: selectedEligibility?.name || "",
          value: selectedEligibility?._id || "",
        },
        value: getSelectedValues(),
        file: null, // Clear file input on reset
        mediaType: detectedMediaType,
      });
    } else if (!isEditVideo) {
      reset({
        name: "",
        eligibilityCriteria: null,
        value: null,
        file: null,
        mediaType: 'video',
      });
      setMediaType('video');
      setPreviousFiles([]);
      setPreviousFile("");
    }
  }, [isOpen, videoData, isEditVideo, eligibilityCriteriaData, reset]);

  const [isResetFile, setIsResetFile] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  const { mutate: addOurStory, isPending: loading } = useAddOurStory();
  const { mutate: updateOurStory, isPending: updateLoading } =
    useUpdateOurStory({ id: videoData?._id });
  const { resetUpload } = useUploadProgress();

  const onSubmit = async (data: IFormData) => {
    const formData = new FormData();
    
    const payloadData = {
      name: data.name,
      eligibilityCriteria: data.eligibilityCriteria?.value,
      value: Array.isArray(data.value)
        ? data.value.map((item) => item.value)
        : data.value?.value || null,
      mediaType: data.mediaType,
    };

    formData.append("data", JSON.stringify(payloadData));

    if (isEditVideo) {
      if (data.file) {
        if (data.mediaType === 'video') {
          // Single video file
          formData.append("file", data.file as File);
          const thumbnailFile = await generateThumbnail(data.file as File);
          formData.append("thumbnail", thumbnailFile);
        } else {
          // Multiple image files
          const files = Array.isArray(data.file) ? data.file : [data.file];
          files.forEach((file, index) => {
            formData.append(`file_${index}`, file);
          });
          formData.append("fileCount", files.length.toString());
        }
      }
    } else if (data.file) {
      if (data.mediaType === 'video') {
        // Single video file
        formData.append("file", data.file as File);
        const thumbnailFile = await generateThumbnail(data.file as File);
        formData.append("thumbnail", thumbnailFile);
      } else {
        // Multiple image files
        const files = Array.isArray(data.file) ? data.file : [data.file];
        files.forEach((file, index) => {
          formData.append(`file_${index}`, file);
        });
        formData.append("fileCount", files.length.toString());
      }
    }

    if (isEditVideo) {
      updateOurStory(formData, {
        onSuccess: async (res) => {
          toast.success(res.result.message);
          clearValues();
          onSuccess?.();
        },
        onError: (err) => {
          toast.error(err?.response?.data?.result?.message);
        },
      });
    } else {
      addOurStory(formData, {
        onSuccess: async (res) => {
          closeModal?.();
          toast.success(res.result.message);
          await queryClient.refetchQueries({ queryKey: ["our-story"] });
          clearValues();
          resetUpload();
          navigate(`/${params.hotelcode}/tv-app/home/home`);
        },
        onError: (err) => {
          resetUpload();
          toast.error(err?.response?.data?.result?.message);
        },
      });
    }
  };

  const clearValues = () => {
    methods.reset({
      name: "",
      eligibilityCriteria: null,
      value: null,
      file: null,
      mediaType: 'video',
    });
    methods.setValue("file", null);
  };

  const generateThumbnail = async (videoFile: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      video.src = URL.createObjectURL(videoFile);

      video.onloadedmetadata = () => {
        canvas.width = 800;
        canvas.height = 450;

        video.currentTime = 0.1;

        video.onseeked = () => {
          if (!ctx) {
            reject(new Error("Canvas context not available"));
            return;
          }

          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error("Failed to create thumbnail blob"));
                return;
              }

              const thumbnailFile = new File(
                [blob],
                `${videoFile.name}-thumbnail.jpg`,
                {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                }
              );

              URL.revokeObjectURL(video.src);
              resolve(thumbnailFile);
            },
            "image/jpeg",
            0.9
          ); // 90% quality
        };

        video.onerror = () => {
          reject(new Error("Video loading error"));
        };
      };
    });
  };
  const handleClose = () => {
    reset({
      name: "",
      eligibilityCriteria: null,
      value: null,
      file: undefined,
      mediaType: 'video',
    });
    setValue("file", null);
    methods.trigger("file");
    setMediaType('video');
    setPreviousFiles([]);
    setPreviousFile("");
    setIsResetFile(true);
    closeModal?.();
  };

  useEffect(() => {
    if (isResetFile) {
      setIsResetFile(false);
    }
  }, [isResetFile]);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={loading || updateLoading ? () => {} : handleClose}
      title={modalTitle || "Add Our Story"}
      className="w-144.75"
    >
      <FormProvider {...methods}>
        <div
          style={{
            height: "500px",
            overflowY: "scroll",
            padding: "0 10px 0 0",
          }}
        >
          <TextInput
            label="Media Name"
            placeholder="Hotel Overview"
            name="name"
            rules={{
              required: "Name is required",
            }}
          />
          <div className="flex items-start gap-2 mt-6.5">
            <Select
              label="Select Guest type"
              rules={{ required: "Guest type is required" }}
              options={eligibilityOptions}
              name="eligibilityCriteria"
              className="w-60"
              onChange={(event) => {
                const selectedEligibility =
                  eligibilityCriteriaData?.result?.data.find(
                    (ele) => ele._id === event.value
                  );
                setValueTypeEligibility({
                  key: DynamicMultiSelectKeys.includes(
                    selectedEligibility?.key!
                  )
                    ? "RESERVATION_NO"
                    : selectedEligibility?.key ?? "",
                  valueType: DynamicMultiSelectKeys.includes(
                    selectedEligibility?.key!
                  )
                    ? "DYNAMIC_MULTI_SELECT"
                    : selectedEligibility?.valueType ?? "",
                });
                setValue("value", null);
              }}
            />
            {valueTypeEligibility.valueType === "TEXT" && (
              <TextInput
                name="Select Values"
                value={
                  valueTypeEligibility?.key === "MINIMUM_FOLIO_CHARGE"
                    ? `$${methods.watch("value.value") || ""}`
                    : String(methods.watch("value.value") || "")
                }
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/\$/g, "");
                  setValue("value", { label: inputValue, value: inputValue });
                }}
                rules={{
                  required: "Value is required",
                }}
                label="Select Values"
                placeholder={`Enter value`}
                // disabled={isDisabled}
              />
            )}
            {valueTypeEligibility.valueType === "DYNAMIC_MULTI_SELECT" && (
              <DynamicMultiSelect
                name="value"
                rules={{
                  required: "Value is required",
                  validate: (value) =>
                    (Array.isArray(value) && value.length > 0) ||
                    "At least one value must be selected",
                }}
                isMulti
                label="Select Values"
                placeholder={`Select ${eligibilityCriteria?.label}`}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                checkboxOptions={true}
                wrapperComponentStyle="col-start-2 -col-end-1 min-w-[50%] w-fit"
                dynamicOptionsReset={dynamicOptionsReset}
                handleDynamicOptionsReset={handleDynamicOptionsReset}
              />
            )}
            {valueTypeEligibility.valueType === "SINGLE_SELECT" && (
              <Select
                label="Select Values"
                rules={{
                  required: "Value is required",
                }}
                options={eligibilityCriteriaOptions}
                name="value"
                className="w-60"
              />
            )}
            {valueTypeEligibility.valueType === "MULTI_SELECT" && (
              <Select
                name="value"
                rules={{
                  required: "At least one value must be selected"
                }}
                isMulti
                label="Select Values"
                placeholder={`Select ${eligibilityCriteria?.label}`}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                checkboxOptions={true}
                wrapperComponentStyle="col-start-2 -col-end-1 min-w-[50%] w-fit"
                options={eligibilityCriteriaOptions}
              />
            )}
          </div>

          {/* Media Type Selection */}
          <div className="mt-6">
            <label className="text-sm leading-[18.03px] font-normal text-[#666672] mb-2 block">
              Media Type
            </label>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="video"
                  checked={watchedMediaType === 'video'}
                  onChange={(e) => {
                    setValue('mediaType', e.target.value as 'video' | 'image');
                    setMediaType(e.target.value as 'video' | 'image');
                    setValue('file', null);
                  }}
                  disabled={isEditVideo}
                  className="mr-2"
                />
                Video
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="image"
                  checked={watchedMediaType === 'image'}
                  onChange={(e) => {
                    setValue('mediaType', e.target.value as 'video' | 'image');
                    setMediaType(e.target.value as 'video' | 'image');
                    setValue('file', null);
                  }}
                  disabled={isEditVideo}
                  className="mr-2"
                />
                Image
              </label>
            </div>
          </div>

          <div className="mt-11.25">
            {/* Previous Files Display */}
            {(previousFile || previousFiles.length > 0) && (
              <>
                <label className="text-sm leading-[18.03px] font-normal text-[#666672]">
                  Previous Files
                </label>
                <div className="mt-2">
                  {mediaType === 'video' && previousFile && (
                    <div className="mb-4">
                      
                        <video
                          src={previousFile}
                          controls
                          className="w-full max-w-xl rounded-lg"
                        />
                    </div>
                  )}
                  { mediaType === 'image' && previousFiles.length > 0 && (
                    <div className="grid grid-cols-4 gap-4">
                      {previousFiles.map((fileUrl, index) => (
                        <div key={index} className="relative">
                          <img
                            src={fileUrl}
                            alt={`Previous file ${index + 1}`}
                            className="w-full h-24 object-cover rounded-lg"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
            
            {watchedMediaType === 'video' ? (
              <VideoRangeSelector
                label="Upload Video"
                name="file"
                onChange={(file) => methods.setValue("file", file)}
                onClear={() => methods.setValue("file", null)}
                maxDuration={maxVideoDuration}
                rules={{
                  required:
                    isEditVideo && (previousFile || previousFiles.length > 0) ? false : "Video is required",
                }}
                accept="video/mp4,video/x-m4v,video/*,.mkv,.mov,.webm"
              />
            ) : (
              <FileDropZone
                label="Upload Images"
                name="file"
                onChange={(files) => methods.setValue("file", files)}
                onClear={() => methods.setValue("file", null)}
                rules={{
                  required:
                    isEditVideo && (previousFile || previousFiles.length > 0) ? false : "At least one image is required",
                  validate: (value) => {
                    // If we have previous files, validation should pass
                    if (previousFile || previousFiles.length > 0) {
                      return true;
                    }
                    // If no previous files, then we need new files
                    if (!value || (Array.isArray(value) && value.length === 0)) {
                      return "At least one image is required";
                    }
                    return true;
                  }
                }}
                accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                multiple={true}
                maxFiles={maxImages}
              />
            )}
          </div>
        </div>

        <div className="flex items-center justify-end gap-[18px] mt-9">
          <Button
            className="w-25.5"
            onClick={handleClose}
            disabled={loading || updateLoading}
          >
            Discard
          </Button>
          <Button
            className="w-auto"
            variant="primary"
            loading={loading || updateLoading}
            disabled={loading || updateLoading}
            onClick={handleSubmit(onSubmit)}
          >
            {uploadPercentage > 0 && uploadPercentage < 100
              ? `${uploadPercentage}%`
              : isProcessing
              ? "Processing..."
              : isEditVideo
              ? "Update"
              : "Save"}
          </Button>
        </div>
      </FormProvider>
    </Modal>
  );
};

export default AddOurStortyModal;
